import axios from "axios";
import API_URL from "../Config";

export const isExcavationSummary = data => [data?.commonFields, Array.isArray(data?.workDetails) ? data.workDetails[0] : data?.workDetails]
  .some(item => String(item?.work_permit_name || "").trim().toLowerCase() === "excavation clearance/road closure");

export function getExcavationWorkLocation(work = {}) {
  const text = value => value === null || value === undefined ? "" : String(value).trim();
  return text(work.facility_location) || text(work.work_location) ||
    [work.area, work.unit].map(text).filter(Boolean).join(" / ") || text(work.location);
}

export async function fetchExcavationViewData(permitId, headers, summary) {
  const [work, approvals] = await Promise.allSettled([
    axios.get(`${API_URL}/api/get_permit_work_details/${permitId}`, { headers }),
    axios.get(`${API_URL}/api/permit/department/approvals/${permitId}`, { headers }),
  ]);
  const savedWork = work.status === "fulfilled" ? work.value.data?.permit_details?.[0] : null;
  const departments = approvals.status === "fulfilled" ? approvals.value.data?.department_approvals : null;
  const fallbackWork = Array.isArray(summary.workDetails) ? summary.workDetails[0] : summary.workDetails;
  return {
    ...summary,
    excavationView: {
      work: { ...summary.commonFields, ...fallbackWork, ...(savedWork || {}) },
      departments: Array.isArray(departments) ? departments : summary.departmentApprovals || [],
      warning: [!savedWork && "Saved work details could not be loaded.", !Array.isArray(departments) && "The latest department approvals could not be loaded."].filter(Boolean).join(" "),
    },
  };
}

export function formatExcavationWorkflowDate(value) {
  // Backend timestamps without an offset must not inherit the browser's timezone.
  const timestamp = typeof value === "string" ? value.trim() : value;
  const utcTimestamp = typeof timestamp === "string" &&
    /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(timestamp)
    ? `${timestamp.replace(" ", "T")}Z`
    : timestamp;
  return formatExcavationDate(utcTimestamp);
}

export function formatExcavationDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
    ...(/^\d{4}-\d{2}-\d{2}$/.test(value) ? {} : { hour: "2-digit", minute: "2-digit", hour12: true }),
    timeZone: "Asia/Kolkata",
  });
}

export function excavationInputValue(input) {
  const value = input.field_value;
  if (value === null || value === undefined || value === "") return "—";
  if (input.field_type === "boolean") {
    if ([true, "true", 1, "1"].includes(value)) return "Yes";
    if ([false, "false", 0, "0"].includes(value)) return "No";
  }
  if (input.field_name === "Date") return formatExcavationDate(value);
  return String(value);
}
